import React from "react";
import { ThumbDown, ThumbUp } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import "./RatingCard.scss";

const PrettoSlider = withStyles({
    root: {
        color: "#fefefe",
        height: 2,
        padding: 0,
        margin: 0,
    },
    thumb: {
        height: 24,
        width: 24,
        backgroundColor: "transparent",
        border: "solid 4.5px #fefefe",
        marginTop: -12,
        marginLeft: -12,
        "&:focus, &:hover, &$active": {
            boxShadow: "inherit",
        },
    },
    active: {},
    valueLabel: {
        left: "-50%",
        top: -22,
        "& *": {
            background: "rgba(255, 255, 255, 0.7)",
            color: "#000",
        },
    },
    track: {
        height: 2,
        borderRadius: 4,
    },
    rail: {
        height: 2,
        borderRadius: 4,
    },
})(Slider);

type Props = {
    question: string;
    rating: number;
    onChange?: (rating: number) => any;
};

const RatingCard: React.FC<Props> = ({ question, rating, onChange }) => {
    function getColor() {
        if (rating < 3.3) {
            return "#f0938f";
        } else if (rating < 6.6) {
            return "#e0e0e0";
        } else {
            return "#72d6a1";
        }
    }

    function getRemark() {
        if (rating < 3.3) {
            return (
                <div className="remark">
                    <ThumbDown className="danger" />{" "}
                    <span className="danger">Poor</span>
                </div>
            );
        } else if (rating < 6.6) {
            return <div className="remark">Just ok</div>;
        } else {
            return (
                <div className="remark">
                    <ThumbUp className="success" />{" "}
                    <span className="success">Excellent</span>
                </div>
            );
        }
    }

    const change = (event: any, newValue: number | number[]) => {
        if (!!onChange) {
            onChange(newValue as number);
        }
    };

    return (
        <div className="rating_card">
            <div>{question}</div>
            <div
                className="progress_bar"
                style={{ backgroundColor: getColor() }}
            >
                <PrettoSlider
                    valueLabelDisplay="auto"
                    aria-label="pretto slider"
                    max={10}
                    min={0}
                    value={rating}
                    onChange={change}
                />
            </div>
            {getRemark()}
        </div>
    );
};

export default RatingCard;
